 /*
 * Service: 승인잔액 조회 서비스
 * Author: KimHyunSoo
 * Date: 2021-04-26
 */

import GentleWidget from '../common/widget';
import GentleLang from '../common/lang';
import GentleComponentButton from '../component/button';
import GentleComponentBubble from '../component/bubble';
import GentleProxy from '../common/proxy';
import GentleAppState from '../common/appstate';
import GentleUtil from '../common/util';
import GentleServiceProduct from './product';
import GentleServiceOrder from './order';
import _const from '../common/const';
import language from '../lang';
import GentleServiceAccount from './account';
import GentleServiceSales from './sales';
// import GentleServiceTip from './tip';
import GentleServiceSchedule from './schedule';
import GentleServiceBonus from './bonus';
import GentleServiceCustomHandler from '../service/customServiceHandler';

var GentleServiceHome = Object.create( GentleWidget,{
    sponserId:{ writable: true, configurable: false, enumerable: true},
    sponserName: { writable: true, configurable: false, enumerable: true}
})

GentleServiceHome.hello = function(){
    if(window.chatbotLoaded){
        // do nothing
    }
    else if(GentleAppState.isLogin){

        window.chatbotLoaded = true;
        const {custName, CurrentMastership} = GentleAppState;
        console.log('Hello', custName, CurrentMastership );

        {
            const {custName, MaxMasterShip} = GentleAppState;

            // 직급자 아닐경우 : 안녕하세요, $user.name$님!
            let html = GentleLang.translateService(language.product, language.product.type.Hello, {name: custName});

            // 직급자의 경우 명목직급을 넣어 주세요:  Ex) 안녕하세요, 김토미 샤론로즈마스터님!
            if(MaxMasterShip){
                const level = GentleLang.mastershipType(MaxMasterShip);
                html = GentleLang.translateService(language.product, language.product.type.Hello2, {name: custName, level});
            }

            window.chatbotBubbles = [];
            window.chatbotBubbles.push(html);

            // var bubble = Object.create( GentleComponentBubble );   
            // bubble.createComponent({
            //         html,
            // });
            // bubble.insert();
        }
    }
}

// 처음으로
GentleServiceHome.main = function(){
    console.log('GentleServiceHome.main');
    
    const component =  Object.create(this);

    // 로그인 안한 경우
    const caseNotLogin = function(){
        const lang = GentleAppState.lang.toUpperCase();

        const string = {
            papa:{
               kr: {
                title: '애터미 회원이신가요?',
                comment: '로그인하면, 더 많은 안내를 받을 수 있어요.',
                buttonLogin: '로그인하기'
               },
               eng: {
                title: 'Are you an Atomy member?',
                comment: 'Log in for more information.',
                buttonLogin: 'Log in'
               }
            }
        }
        const title = (lang === GentleLang.lang.KR) ? string.papa.kr.title : string.papa.eng.title;
        // const comment = (lang === GentleLang.lang.KR) ? string.papa.kr.comment : string.papa.eng.comment;
        const buttonLogin = (lang === GentleLang.lang.KR) ? string.papa.kr.buttonLogin : string.papa.eng.buttonLogin;

        let html = `
        <div class="card-view">
            <div class="banner-container">
                <h3>${title}</h3>
                <figure class="gentle-banner">
                    <img src = "/assets/images/banner/${lang === GentleLang.lang.KR ? 'b5.svg': 'b5_en.png'}">
                </figure>
                <div class="gentle-button-group">
                    <div class="wide-button">
                        <button type="button" class="primary default">${buttonLogin}</button>
                    </div>
                </div>
            </div>
        </div>
        `

        let $container = $(html)

        $container.find('button').bind('click', function(){
            console.log('로그인하기');

            GentleComponentBubble.insertUserBubble({html:buttonLogin});
        });

        component.setPrefix("home");
        component.init($container);
        component.insert();
        // button
        // {
        //     const text = GentleLang.translate(GentleLang.type.AtomyNewProduct);
        //     const option = [
        //         {
        //             isSecondary: true,
        //             isCardWidth: true,
        //             text: text,
        //             user: 'user',
        //             // onClick: function () {
        //             //     console.log('신상품 보기');
        //             //     GentleComponentBubble.insertUserBubble({html})
        //             // },
        //         },
        //     ]
        //     var button = Object.create( GentleComponentButton);
        //     button.createComponent(option);
        //     button.insert();
        // }
        // {
        //     const text = GentleLang.translate(GentleLang.type.AtomyBestProduct);
        //     const option = [
        //         {
        //             isSecondary: true,
        //             isCardWidth: true,
        //             text: text,
        //             user: 'user',
        //             // onClick: function () {
        //             //     console.log('인기상품');
        //             //     GentleComponentBubble.insertUserBubble({html})
        //             // },
        //         },
        //     ]
        //     var button = Object.create( GentleComponentButton);
        //     button.createComponent(option);
        //     button.insert();
        // }

        return;
    }

    const casePapa = function(){
        console.log('casePapa');

        const type = Math.floor(Math.random() * 3);

        switch (type) {
            case 0:
                // 인기상품 조회
            console.log("in")

                GentleServiceProduct.bestList();
            break;
            case 1:
                // 최근주문내역
            console.log("in")

                GentleServiceOrder.main();
            break;
            case 2:
                // 신상품 조회
            console.log("in")

                GentleServiceProduct.newList();
            break;
            default:
            console.log("in")

                break;
        }        
    }

    // main하고 로직이 같은데 회원초대방법을 안내하는 부분만 다르다...
    // 이걸 하나의 메소드로 두기도 뭐하고... 
    const caseTomy = function()                
    {
        const today = new Date();
        const h = today.getHours();
        console.log('h>', h);

        const y = today.getFullYear();
        const m = today.getMonth() + 1;
        const d = Number(today.getDate());
        let lastDay;  // 이번달 마지막 날
        {
            let temp = new Date(y, m, -3);
            lastDay = temp.getDate();
            console.log('lastDay', lastDay);
        }

        let isInTime = true; // 00~09:00 or 12~21:59
        {
            // 00~08:59 or
            if(
                (h > 8 && h < 12)
                || (h > 21 && h < 23)
            ){
                isInTime = false; // 표에서 하단
            }
        }

        let isInDays = false;
        {                        
            if(
                (d > 11 && d < 20) // 11< today < <20
                || d < 4
                || d > lastDay
            ){
                isInDays = true;
            }
        }

        // test code
        // isInTime = false;
        // isInDays = false;

        // todo : 
        if(isInTime)
        {
            const visitCount = (localStorage.visitCount ? localStorage.visitCount : 0) % 4;
            console.log('visitCount>', visitCount);
            localStorage.visitCount = visitCount + 1;

            switch (visitCount) {
                case 0:
                    // 현황조회
                    // GentleServiceSales.main();
                    break;
                case 1:
                    // 오늘 일정
                    // GentleServiceSchedule.main();
                    break;
                case 2:
                    // 최근 주문내역
                    GentleServiceOrder.main()
                    break;
                case 3:
                    // GentleServiceTip.invite(); // 회원초대 방법
                    GentleServiceCustomHandler.handler({
                        service: 'GentleServiceTip.invite',
                    })
                    break;                        
                default:
                    break;
            }
        }
        else
        {
            if(isInDays){
                // 직급내역 +
                // 후원수당(3일간 하위매출)
                {
                    const lang = GentleAppState.lang.toUpperCase();
                    const name = GentleAppState.custName;
                    const html = lang === GentleLang.lang.KR ? 
                        `안녕하세요. ${name}님, 최근 직급내역과 후원수당을 보여드리겠습니다. 정산 마감 시점에 매출 변동이 생기면 내역도 변경될 수 있어요.` 
                        : `Hello, ${name}. We will show you the latest Mastership Achievement and general commission. If there is a change in sales at the end of the settlement period, the details may also change.`
                    var bubble = Object.create( GentleComponentBubble );   
                    bubble.createComponent({
                            html,
                    });
                    bubble.insert();
                }

                const completed = function(){
                    GentleServiceCustomHandler.handler({
                        service: 'GentleServiceBonus.huwonBonus',
                        simple: true,
                    });
                }

                GentleServiceBonus.positionPay({completed, simple: true});
            }
            else{
                GentleServiceBonus.huwonBonus({});    // 후원수당
            }
        }

    }

    // 사업자 tomy
    // const caseTomy = function(){
    //     console.log('caseTomy');

    //     let baseTime = '';  // 정산기준 시간
    //     let baseDay;   // 날짜

    //     GentleProxy.requestBaseTime(function(data){                    
    //         baseTime = data;
    //         let arr = baseTime.split(' ');
    //         arr = arr[0].split('-');
    //         baseDay = Number(arr[2]);
    
    //         // $date.html(GentleLang.translateService(language.bonus, language.bonus.type.BasedTime, {date}));
    //         request();
    //     })

    //     const request = function(){
    //         const PageSize = 2;
    
    //         const onSuccess = function(data){
    //             console.log('onSuccess>', data);
    //             switch(data.Status){
    //             case 1:
    //                 const { Data } = data;
    //                 console.log('Data>', Data);
    
    //                 if(Data.length > 0){
    //                     curPage = page;
    //                 }
            
    //                 render(Data);
    //                 break;
    //             default:
    //                 break;
    //             }
    //         };
        
    //         const onFailed = function(data){
    //             console.log('onFailed');    
    //         }
    
    //         const proxy = Object.create(GentleProxy);
    //         const param = {PageNo: 1, PageSize: 10, StartDate:'', EndDate:''};
    //         proxy.request("mastership", param, onSuccess, onFailed );
    //     }
    //     // request();
    
    //     const render = function(data){
    //         console.log('data>', data);

    //         const {CurrentMastership, LastPv, MaxMastership} = data;
            
    //         const name = GentleAppState.custName;
    
    //         // 봇버블
    //         const html1 = GentleLang.translateService(language.home, language.home.type.Bot, {name});
    //         const html2 = GentleLang.translateService(language.home, language.home.type.Bot2);
    //         {
    //             var bubble = Object.create( GentleComponentBubble );   
    //             bubble.createComponent({
    //                     "html": [ html1, html2],
    //             });
    //             bubble.insert();
    //         }
    
    //         // 카드
    //         {            
    //             const titleMe = GentleLang.translateService(language.bonus, language.bonus.type.MySales);
    //             const titlePosition = GentleLang.translate(GentleLang.type.Position);
    //             const titleLeft = GentleLang.translate(GentleLang.type.Left);
    //             const titleRight = GentleLang.translate(GentleLang.type.Right);
    //             const MastershipHistory = GentleLang.translateService(language.bonus, language.bonus.type.MastershipHistory);
    //             const titleButton = GentleLang.translateService(language.bonus, language.bonus.type.PositionPayMore);

    //             const {MastershipAchievementItems, SalesMasterAchievementItems} = data; // array

    //             let Date, Mastership;
    //             if(MastershipAchievementItems){
    //                 const item = MastershipAchievementItems[0];
    //                 Date = item.Date;
    //                 Mastership = item.Mastership;
    //             }

    //             let LeftPv= '', RightPv = '', BasicPv = '0', MinPv, Dealership, SalesMastership;
    //             if(SalesMasterAchievementItems){
    //                 const item = SalesMasterAchievementItems[0];
    //                 // item.Date;
    //                 // item.CustNo;
    //                 LeftPv = item.LeftPv;
    //                 RightPv = item.RightPv; 
    //                 BasicPv = item.BasicPv;
    //                 MinPv = item.MinPv;
    //                 Dealership = item.Dealership;
    //                 SalesMastership = item.Mastership;
    //             }
        
    //             let sales = BasicPv;
    //             sales = GentleUtil.comma(sales);
    //             sales = GentleLang.translate(GentleLang.type.CurrencyFormat2, {num: sales});
        
    //             // 직급 
    //             let position = GentleLang.mastershipType(Mastership);

    //             let htmlSale = '';
    //             if(SalesMasterAchievementItems){
    //                 htmlSale = `
    //                 <div class="flex-box-2 center">
    //                     <div>
    //                         <strong>${titleLeft}</strong>
    //                         <hr class="mt-8">
    //                         <strong><em>${left}</em> PV</strong>
    //                     </div>
    //                     <div>
    //                         <strong>${titleRight}</strong>
    //                         <hr class="mt-8">
    //                         <strong><em>${right}</em> PV</strong>
    //                     </div>
    //                 </div>`;
    //             }

    //             let html = `
    //             <div class="card-view">
    //                 <div class="margin-container">
    //                         <h3>${MastershipHistory}</h3>
    //                     <span class="time-label">${GentleLang.translateService(language.bonus, language.bonus.type.BasedTime, {date:baseTime})}</span>
    //                     <div class="flex-box-2 space-beetween">
    //                         <span>${titleMe}</span>
    //                         <span>${sales}</span>
    //                     </div>
                
    //                     <div class="flex-box-2 space-beetween">
    //                         <span>${titlePosition}</span>
    //                         <span><strong>${position}</strong></span>
    //                     </div>
    //                 </div>
    //                 <div class="account-box">
    //                     ${htmlSale}
    //                 </div>
    //             </div>            
    //             `;

    //             // component 초기화. 이 코드 후에 레퍼런스로 접근
    //             {
    //                 let $container = $(html)
    //                 component.setPrefix("search");
    //                 component.init($container);
    //                 component.insert();
    //             }

    //             // bind
    //             {
    //                 // const $date = component.find('.time-label');
    //                 // GentleProxy.requestBaseTime(function(date){                    
    //                 //     $date.html(GentleLang.translateService(language.bonus, language.bonus.type.BasedTime, {date}));
    //                 // })
    //             }

    //             // button
    //             // if(!simple)
    //             // {
    //             //     component.find('button').bind('click',function() {
    //             //         console.log('더 많은 직급내역 보기');
    //             //         const url = GentleAppState.isPc ? language.url.pc.SeeMoreMastership : language.url.mobile.SeeMoreMastership;
    //             //         window.open(url);
    //             //         // (GentleAppState.isPc) ? window.open(language.url.pc.SeeMoreMastership) : window.open(language.url.mobile.SeeMoreMastership);
    //             //     });
    //             // }
    //         }
   
    //         // button
    //         {
    //             const text = GentleLang.translateService(language.home, language.home.type.Button);
    //             const option = [
    //                 {
    //                     text: text,
    //                     user: 'user',
    //                     onClick: function () {
    //                         console.log(text);
    //                         // todo : 하위매출 보기
    //                     },
    //                 },
    //             ]
    //             var button = Object.create( GentleComponentButton);
    //             button.createComponent(option);
    //             button.insert();
    //         }
    //         GentleUtil.timeStamp();
    //     };
    // }

    // 분기
    // 로그인하지 않은 경우
    console.log('GentleAppState>', GentleAppState);

    const {isLogin, persona} = GentleAppState;

    if(isLogin){
        if(persona === GentleLang.persona.PAPA)
            casePapa();
        else
            caseTomy();
    }
    else{
        const type = Math.floor(Math.random() * 3);

        switch (type) {
            case 0:
                {
                    const html = GentleLang.translate(GentleLang.type.Hello);
                    var bubble = Object.create( GentleComponentBubble );   
                    bubble.createComponent({
                            html,
                    });
                    bubble.insert();
                }
                caseNotLogin();                        
                break;
            case 1:
                // GentleServiceProduct.bestList();
                {
                    const html = GentleLang.translate(GentleLang.type.Hello);
                    var bubble = Object.create( GentleComponentBubble );   
                    bubble.createComponent({
                            html,
                    });
                    bubble.insert();
                }
                caseNotLogin();       
                break;
            case 2:
                // GentleServiceProduct.newList();
                {
                    const html = GentleLang.translate(GentleLang.type.Hello);
                    var bubble = Object.create( GentleComponentBubble );   
                    bubble.createComponent({
                            html,
                    });
                    bubble.insert();
                }
                caseNotLogin();       
                break;        
            default:
                break;
        }

    }
}

export default GentleServiceHome;